<script>
import { mapActions, mapState } from "vuex";

import dateMixin from "@/mixins/dateMixin";
import accountMixin from "@/mixins/accountMixin";

import New from "./New";
import ProfileRow from "@/components/_Shared/Users/Profile/Row";

export default {
  mixins: [dateMixin, accountMixin],

  components: {
    New,
    ProfileRow
  },

  data() {
    return {
      newPhysical: false,
      selected: [],
      headers: [
        { text: "Nome", value: "name" },
        { text: "Cidade", value: "city" },
        { text: "Email", value: "email" },
        { text: "Criado em", value: "created_at" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions" }
      ]
    };
  },

  computed: {
    ...mapState("physicals", ["list", "pagination", "preloader", "text_search"])
  },

  methods: {
    ...mapActions("physicals", ["index", "setCurrentPage", "setTextSearch"]),

    initialize() {
      this.index();
    },

    input(value) {
      this.setCurrentPage(value);
    }
  },

  mounted() {
    this.initialize();
  }
};
</script>

<template>
  <div>
    <v-layout row align-center justify-space-between class="mb-10">
      <div class="new-group mb-0" @click="newPhysical = !newPhysical">
        <img src="/static/plus.svg" /> Cadastrar novo B2C
      </div>

      <v-flex md4>
        <v-text-field
          :value="text_search"
          @keypress.enter="setTextSearch($event.target.value)"
          append-icon="search"
          label="Buscar"
          hide-details
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="list"
      :loading="preloader"
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>
              <profile-row :account="item" />
            </td>
            <td>
              <v-chip small outlined>{{ item.profile.city_name }}</v-chip>
            </td>
            <td class="text-lowercase">
              <v-chip small outlined>{{ item.email }}</v-chip>
            </td>
            <td>
              <v-chip small outlined>
                {{ item.created_at | formatDate("DD/MM/Y H:mm") }}
              </v-chip>
            </td>
            <td>
              <v-chip
                small
                outlined
                class="darken-1"
                :color="item.status | getAccountStatus('color')"
                >{{ item.status | getAccountStatus }}</v-chip
              >
            </td>
            <td>
              <router-link
                :to="{ name: 'clients-b2b-edit', params: { id: item.id } }"
              >
                <v-btn color="primary" outlined small rounded>editar</v-btn>
              </router-link>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <div class="text-xs-center pt-2">
      <v-pagination
        v-model="pagination.current"
        :length="pagination.totalPages"
        @input="input"
        circle
      ></v-pagination>
    </div>

    <new v-show="newPhysical" @close="newPhysical = false" @refresh="index()" />
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Customers/Physicals/Index.vue